<!-- =========================================================================================
  File Name: BookAdd.vue
  Description: Book Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-book-meta-add">

    <vx-card title="교재 메타정보 추가" class="mb-base" >
      <book-meta-add-form class="mt-4" />
    </vx-card>

  </div>
</template>

<script>
import BookMetaAddForm  from './BookMetaAddForm'

export default {
  components: {
    BookMetaAddForm
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
  
}

</script>
